import {
  Box,
  Button,
  FormControl,
  HStack,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Trans } from "react-i18next";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renders the AI form
 * 
 * @param {Function} register The form registration function
 * @param {Function} copyToClipboard The copy to clipboard function
 * @returns The AI form
 */
const AiForm = ({ register, copyToClipboard, content }) => {
  return (
    <VStack height={"full"}>
      {content ? (
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={3}
          alignItems={"flex-start"}
          textAlign={"start"}
          borderWidth="1px"
          borderColor="#744AAB"
          bgGradient="linear(#54C0E830, #9747FF30)"
          borderRadius="10px"
          color="white"
          padding={"12px"}
          height={"full"}
          maxH={"400px"}
          width={"full"}
          overflowY={"scroll"}
          whiteSpace="pre-wrap"
          sx={{
            "*": {
              fontSize: "12px"
            },
            h1: {
              fontSize: "24px",
              fontWeight: "bold",
              mb: 3,
              lineHeight: 1.2,
            },
            h2: {
              fontSize: "16px",
              fontWeight: "bold",
              mb: 2,
              lineHeight: 1.3,
            },
            h3: {
              fontSize: "12px",
              fontWeight: "semibold",
              mb: 2,
            },
            p: {
              mb: 2,
            },
            strong: {
              fontWeight: "bold",
              color: "white",
            },
            ul: {
              paddingLeft: "20px",
              mb: 2,
            },
            ol: {
              paddingLeft: "20px",
              mb: 2,
            },
            li: {
              mb: 1,
            },
            table: {
              width: "100%",
              borderCollapse: "collapse",
              my: 3,
            },
            th: {
              border: "1px solid",
              borderColor: "white",
              px: 2,
              py: 2,
              textAlign: "left",
            },
            td: {
              border: "1px solid",
              borderColor: "gray.100",
              px: 2,
              py: 2,
            },
          }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {content}
          </ReactMarkdown>
        </Box>
      ) : (
        <FormControl height={"full"}>
          <Textarea id="ai" height={"full"} backgroundColor={"#2D313A"} borderRadius={"10px"} color={"gray.400"} readOnly {...register("ai")} />
        </FormControl>
      )}
      <HStack width={"full"} justifyContent={"space-around"} mt={"8px"}>
        <Button
          size={"md"}
          colorScheme="whiteAlpha"
          onClick={copyToClipboard}
          borderRadius={"10px"}
          width={"full"}
        >
          <Trans>beneficiaryFile.form.copy</Trans>
        </Button>
      </HStack>
    </VStack>
  );
};

export default AiForm;
